module.exports = __webpack_public_path__ + "img/task-open.9a74af0b.svg";